"use client";

import { useState } from "react";

export function ProfileShareCard({ profileId }: { profileId: string }) {
  const [copied, setCopied] = useState(false);
  const url = `https://peakwave.co/candidates/${profileId}`;

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  }

  return (
    <div className="bg-white rounded-[20px] p-6 md:p-7 border border-border-light mb-4 animate-fade-in">
      <div className="flex items-center gap-2 mb-2">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-gold shrink-0"
        >
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
        </svg>
        <h2 className="font-serif text-lg text-navy">Share your profile</h2>
      </div>
      <p className="text-[13px] text-text-muted mb-3">
        Share your profile with employers. Signed-in employers see your full
        profile; anyone else sees only your first name, roles and seasons.
      </p>
      <div className="flex items-center gap-2">
        <input
          type="text"
          readOnly
          value={url}
          className="flex-1 min-w-0 px-3 py-2 rounded-[8px] bg-warm-bg border border-border-light text-[13px] text-text-body font-sans outline-none"
          onClick={(e) => (e.target as HTMLInputElement).select()}
        />
        <button
          onClick={handleCopy}
          className={`px-4 py-2 rounded-sm text-[13px] font-semibold border-none cursor-pointer font-sans transition-all shrink-0 ${
            copied
              ? "bg-success/10 text-success"
              : "bg-gold text-white hover:bg-gold-light"
          }`}
        >
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
